import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback } from 'react';
import { beachballIcon } from '@polkadot/ui-shared';
function Identicon(_ref) {
  let {
    address,
    className = '',
    size,
    style = {}
  } = _ref;
  const updateElem = useCallback(node => {
    node === null || node === void 0 || node.appendChild(beachballIcon(address, {
      isAlternative: false,
      size
    }));
  }, [address, size]);
  return _jsx("div", {
    className: className,
    ref: updateElem,
    style: style
  });
}
export const Beachball = React.memo(Identicon);